export function resolveGraphqlHttpUri(): string {
  const configured = (process.env.REACT_APP_GRAPHQL_SERVER_URI || '').trim();
  if (!configured) return configured;

  if (typeof window === 'undefined' || process.env.NODE_ENV !== 'development') {
    return configured;
  }

  try {
    const api = new URL(configured, window.location.href);
    const page = new URL(window.location.href);
    const isLocalApi =
      api.hostname === 'localhost' || api.hostname === '127.0.0.1';
    if (isLocalApi && api.origin !== page.origin) {
      const path = api.pathname.replace(/\/$/, '') || '/graphql';
      return `${page.origin}${path}`;
    }
  } catch {
    return configured;
  }

  return configured;
}

export function resolvePrintApiBaseUrl(): string {
  return resolveGraphqlHttpUri().replace(/\/graphql\/?$/i, '');
}
